import React from 'react';
import { DynamicComponent } from '../../../common/types/dynamic-comonent-type';
import { TopAreaMiddleButtonTypes } from '../../enums/top-area-button-types';
import PromotionsSummaryMenu from './promotions-summary-menu';
import CouponsSummaryMenu from './coupon-summary-menu'

export const TopAreaSummaryMenu: React.FC<TopAreaSummaryMenuProps> = ({ menu }) => {
  const summaryMenu: DynamicComponent<TopAreaMiddleButtonTypes> = {
    // // Inline switch statement
    promotions: <PromotionsSummaryMenu />,
    // giftCard: (<PlaceholderMenu/>), // Switch based off the menu type
    coupons: <CouponsSummaryMenu />,
  };

  return <>{summaryMenu[menu]}</>;
};

interface TopAreaSummaryMenuProps {
  menu: TopAreaMiddleButtonTypes;
}
